import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import jeopardy from './pictures/womenJeopardy.jpeg';
import slides from './pictures/womensday.jpeg';
import panel from './pictures/panelists.jpeg';
import attendees from './pictures/internationaDayAttendees.jpeg';


const InternationalWomensDay = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>International Women's Day Celebration</h2>
                    <p className="site-post-meta">March 3, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you so much to everyone who came to our annual International Women's Day Celebration! We had the amazing opportunity to hear from our panel: Professor Elba Garza, Professor Taylor Kessler Faulkner, and Professor Natasha Jaques.
                    <br></br>
                    We got to hear about our panel's multitudes of experience, their journey to how they got here, and their experience with being a woman in this industry! We then followed it up with a super fun Jeopardy Game, congrats to our winners, who got to take home a Lego set!
                    <br></br>
                     We hope everyone enjoyed the Fireside chat. Big thank you to Professor Elba, Professor Taylor, and Professor Natasha for their time and sharing so much about their work!
                    <br></br>
                    </p>
                    <img src={panel} alt="Our panel from the event"/>
                    <img src={attendees} alt="Attendees listening to panel speak"/>
                    <img src={slides} alt="Slides from International Womens Day celebration"/>
                    <img src={jeopardy} alt="Playing jeaporday during event"/>
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default InternationalWomensDay;